import React from 'react';

const ToolsContext = React.createContext({ onClose: () => {} });

export default ToolsContext;
